const s = require("./coreMarketGraph.module.scss");

import { default as React, useEffect, useContext, useState } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import Content from "./content";
import httpService from "core/infrastructure/http";
import { MultiSelectItem } from "components/multiselect";
import { MaxNetPosDto, GetMaxNetPosResponse, MaxExchangesDto, GetMaxExchangesResponse } from "core/backend/data";
import ContentPart from "components/contentPart";
import SheetHeader from "components/sheetHeader";
import { ApplicationState } from "core/app";
import classNames from "classnames";
import { keys } from "ts-transformer-keys";
import { PageList } from "core/pages/pageList";

interface OwnState {
    applicationState: ApplicationState;
}
export const senderId = "coreMarketGraph";
export const page_config: PageList =
{
    apiUrl: "",
    webUrl: "coreMarketGraph",
    menu: "menu:menuCoreMarketGraphs",
    title: "menu:titleCoreMarketGraphs",
    apiType: "data",
    response: "",
    dto: "",
    parameters: "",
    dateSteps: "D",
    getDefaultToDateTime: (applicationState: ApplicationState) => applicationState.getUntilFor1Day()
};

type PageProps = OwnState & WithTranslation;

const Page = ({ t, applicationState }: PageProps) => {

    if (!applicationState.initialized) return <div />;

    const borders: string[] = keys<MaxExchangesDto>();
    const hubs: string[] = keys<MaxNetPosDto>().filter(f => f.startsWith("min")).map(f => f.replace("min", "hub_"));

    const selectedBorders = applicationState.selectedBorders.filter((f) => f.selected && f.isDisplayed);

    const initialMaxNetPosData: MaxNetPosDto[] = [];
    const [maxNetPosData, setMaxNetPosData] = useState(initialMaxNetPosData);
    const initialMaxExchangesData: MaxExchangesDto[] = [];
    const [maxExchangesData, setMaxExchangesData] = useState(initialMaxExchangesData);
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [selectedHubs, setSelectedHubs] = useState(
        hubs.map(f => f.replace("hub_", ""))
            .filter(f => !f.startsWith("AL"))// remove albe alde
            .map(h => {
                const x: MultiSelectItem = { id: h, text: h, isDisplayed: true, selected: true };
                return x;
            }).sort((a, b) => a.id.localeCompare(b.id))// ascending
    );

    const loadMaxNetPos = async () => {
        const response = await httpService.apiPost<GetMaxNetPosResponse>({
            applicationState: applicationState,
            route: applicationState.apiService + "/" + page_config.apiType + "/maxNetPos",
            query: {
                FromUtc: applicationState.getRootUtcTime().toISOString(),
                ToUtc: applicationState.getUntilFor1Day().toISOString()
            },
            senderId: senderId
        })();

        if (response.ok) {
            setMaxNetPosData(response.data.data);
            setError("");
        } else {
            setError(response.error || t("common:UnknownError"));
        }
    };
    const loadMaxExchanges = async () => {
        const response = await httpService.apiPost<GetMaxExchangesResponse>({
            applicationState: applicationState,
            route: applicationState.apiService + "/" + page_config.apiType + "/maxExchanges",
            query: {
                FromUtc: applicationState.getRootUtcTime().toISOString(),
                ToUtc: applicationState.getUntilFor1Day().toISOString()
            },
            senderId: senderId
        })();

        if (response.ok) {
            setMaxExchangesData(response.data.data);
            setError("");
        } else {
            setError(response.error || t("common:UnknownError"));
        }
    };
    const setSelected = (id: string) => {
        const newList = selectedHubs.map((item) => {
            if (item.id.startsWith(id)) {
                const updatedItem = {
                    ...item,
                    selected: !item.selected
                };
                return updatedItem;
            }
            return item;
        });
        setSelectedHubs(newList);
    };
    const clearSelection = () => {
        const newList = selectedHubs.map((item) => {
            const updatedItem = {
                ...item,
                selected: false
            };
            return updatedItem;
        });
        setSelectedHubs(newList);
    };


    useEffect(() => {
        (async function runAsync() {
            applicationState.handleInputAvailablilityChange(page_config.dateSteps, true, false, borders.concat(hubs));
            setLoading(true);
            setMaxNetPosData([]);
            setMaxExchangesData([]);
            //we cannot use Promis.All to request both data at the same time because of IP LIMIT
            /*await Promise.all([
                loadMaxNetPos(),
                loadMaxExchanges()
            ]);*/
            await loadMaxNetPos();
            await loadMaxExchanges();

            setLoading(false);
        })();
    }, [applicationState.selectedDate]);

    return (
        <>
            <SheetHeader showDownload={false} applicationState={applicationState} title={t(page_config.title)} pageConfig={page_config} />
            <div className="subHeader">
                <div className={classNames(s.selectableHubs, selectedHubs.filter(h => h.selected).length === 0 ? s.selected : "")} onClick={() => clearSelection()}>{t("common:none")}</div>
                {selectedHubs.map(b => <div className={classNames(s.selectableHubs, b.selected ? s.selected : "")} key={b.id} onClick={() => setSelected(b.id)}>{t("common_hubs:" + b.id)}</div>)}
            </div>
            <ContentPart isLoading={isLoading} data={[]} error={error}>
                <Content maxNetPosData={maxNetPosData} maxExchangeData={maxExchangesData} hubs={selectedHubs.filter(h => h.selected)} borders={selectedBorders} />
            </ContentPart>
        </>
    );
};

export default withTranslation()(Page);
